<template>
    <div id="page-blocks">
        <div v-for="(block, blockIndex) in blocks" :key="blockIndex">
            <div @click="addBlock(blockIndex)" class="border border-dashed text-center cursor-pointer p-2 mb-3">
                <i class="las la-plus-square la-lg text-muted"></i>
            </div>
            <div class="border p-3 mb-3">
                <div class="d-flex justify-content-between">
                    <div class="mb-4 font-weight-bold">{{ block.title }}</div>
                    <input type="hidden" :name="dataMainFieldName + '[' + blockIndex + ']' + '[name]'"
                        :value="block.name">
                    <div class="d-flex">
                        <div class="text-primary cursor-pointer mr-3"
                            @click="blocks.splice(blockIndex - 1, 0, blocks.splice(blockIndex, 1)[0])"><i
                                class="las la-arrow-up"></i></div>
                        <div class="text-primary cursor-pointer mr-3"
                            @click="blocks.splice(blockIndex + 1, 0, blocks.splice(blockIndex, 1)[0])"><i
                                class="las la-arrow-down"></i></div>
                        <div class="text-danger cursor-pointer" @click="blocks.splice(blockIndex, 1)"><i
                                class="las la-trash"></i></div>
                    </div>
                </div>
                <div class="row">
                    <div v-for="(field, fieldIndex) in block.fields" class="form-group mb-3" :class="field.class"
                        :key="fieldIndex">
                        <div v-if="field.type != 'repeatable'">
                            <label>
                                {{ field.label }}<span v-if="field.validation && field.validation.required"
                                    class="text-danger">*</span>
                            </label>
                            <input v-if="field.type === 'text'"
                                @input="field.value = $event.target.value"
                                :name="dataMainFieldName + '[' + blockIndex + '][' + field.name + ']'" :value="field.value"
                                type="text" class="form-control" :class="field.attributes ? field.attributes.class : ''">
                            <div v-else-if="field.type === 'textarea'">
                                <vue-editor
                                    v-model="field.value"
                                    :class="field.attributes ? field.attributes.class : ''"
                                    :rows="field.attributes ? field.attributes.rows : 3" />
                                <input type="hidden" :name="dataMainFieldName + '[' + blockIndex + '][' + field.name + ']'" :value="field.value">
                            </div>
                            <div v-else-if="field.type === 'images'">
                                <draggable v-model="field.value" :disabled="!field.value || field.value.length < 2">
                                    <transition-group class="row">
                                        <div v-for="image in field.value" :key="image"
                                            :class="field.attributes ? field.attributes.class : 'col-md-3 mb-2'">
                                            <div class="position-relative mb-2">
                                                <div class="cursor-pointer position-absolute text-danger bg-white px-2 py-1 shadow-sm border"
                                                    @click="deleteImage(field, image)">
                                                    <i class="las la-trash"></i>
                                                </div>
                                                <div v-if="field.value.length && field.value.length > 1"
                                                    class="cursor-pointer position-absolute right-0 bg-white px-2 py-1 shadow-sm border">
                                                    <i class="las la-arrows-alt"></i>
                                                </div>
                                                <img :src="image" class="w-100 border"
                                                    :class="field.attributes ? field.attributes.img_class : ''">
                                                <input type="hidden"
                                                    :name="dataMainFieldName + '[' + blockIndex + '][' + field.name + '][]'"
                                                    :value="image">
                                            </div>
                                        </div>
                                    </transition-group>
                                </draggable>
                                <input type="file" class="d-none" @change="uploadImage($event, block, field)"
                                    :ref="'input_file_' + blockIndex + '_' + fieldIndex"
                                    :multiple="field.attributes && field.validation.max && field.validation.max == 1 ? false : true">
                                <div class="btn btn-secondary btn-sm mb-2"
                                    @click="openFileInput('input_file_' + blockIndex + '_' + fieldIndex)">
                                    <i class="la la-image"></i> Upload images
                                </div>
                            </div>
                            <!-- ERROR -->
                            <div v-if="errors.length">
                                <div v-for="error in errors"
                                    v-if="error.blockIndex === blockIndex && error.fieldName === field.name"
                                    class="text-danger">{{ error.message }}</div>
                            </div>
                            <!-- HINT -->
                            <div v-if="field.hint"><small class="text-muted" v-html="field.hint"></small></div>
                            <!-- VALIDATION HINT -->
                            <small v-if="field.validation && (field.validation.max || field.validation.min)" class="text-muted">
                                <div v-if="field.type === 'images' && field.attributes && field.attributes.width && field.attributes.height">
                                    Recommended size: {{ field.attributes.width }}x{{ field.attributes.height }}px
                                </div>
                                <div v-if="field.validation.max">Max: {{ field.validation.max }}</div>
                                <div v-if="field.validation.min">Min: {{ field.validation.min }}</div>
                            </small>
                        </div>
                        <div v-else-if="field.type === 'repeatable'" :class="field.class">
                            <div class="border p-3 mb-3" v-for="(subBlock, subBlockIndex) in field.value" :key="subBlockIndex">
                                <div class="d-flex justify-content-between">
                                    <div class="mb-4 font-weight-bold">{{ field.label }}</div>
                                    <div class="d-flex">
                                        <div class="text-primary cursor-pointer mr-3"
                                            @click="field.value.splice(subBlockIndex - 1, 0, field.value.splice(subBlockIndex, 1)[0])"><i
                                                class="las la-arrow-up"></i></div>
                                        <div class="text-primary cursor-pointer mr-3"
                                            @click="field.value.splice(subBlockIndex + 1, 0, field.value.splice(subBlockIndex, 1)[0])"><i
                                                class="las la-arrow-down"></i></div>
                                        <div class="text-danger cursor-pointer"
                                            @click="field.value.splice(subBlockIndex, 1)"><i class="las la-trash"></i></div>
                                    </div>
                                </div>
                                <div v-for="(subField, subFieldIndex) in field.fields" :key="subFieldIndex" class="form-group mb-3">
                                    <label>{{ subField.label }} <span v-if="subField.validation && subField.validation.required"
                                            class="text-danger">*</span></label>
                                    <input v-if="subField.type === 'text'"
                                        @input="subBlock[subField.name] = $event.target.value"
                                        :name="dataMainFieldName + '[' + blockIndex + '][' + field.name + '][' + subBlockIndex + '][' + subField.name + ']'"
                                        :value="subBlock[subField.name]"
                                        type="text" class="form-control" :class="subField.attributes ? subField.attributes.class : ''">
                                    <div v-else-if="subField.type === 'textarea'">
                                        <vue-editor
                                            v-model="subBlock[subField.name]"
                                            :class="subField.attributes ? subField.attributes.class : ''"
                                            :rows="subField.attributes ? subField.attributes.rows : 3" />
                                        <input type="hidden"
                                            :name="dataMainFieldName + '[' + blockIndex + '][' + field.name + '][' + subBlockIndex + '][' + subField.name + ']'"
                                            :value="subBlock[subField.name]">
                                    </div>
                                    <div v-else-if="subField.type === 'images'">
                                        <draggable v-model="subBlock[subField.name]" :disabled="!subBlock[subField.name] || subBlock[subField.name].length < 2">
                                            <transition-group class="row">
                                                <div v-for="image in subBlock[subField.name]" :key="image"
                                                    :class="subField.attributes ? subField.attributes.class : 'col-md-3 mb-2'">
                                                    <div class="position-relative mb-2">
                                                        <div class="cursor-pointer position-absolute text-danger bg-white px-2 py-1 shadow-sm border"
                                                            @click="deleteImage(subField, image)">
                                                            <i class="las la-trash"></i>
                                                        </div>
                                                        <div v-if="subBlock[subField.name] && subBlock[subField.name].length > 1"
                                                            class="cursor-pointer position-absolute right-0 bg-white px-2 py-1 shadow-sm border">
                                                            <i class="las la-arrows-alt"></i>
                                                        </div>
                                                        <img :src="image" class="w-100 border"
                                                            :class="subField.attributes ? subField.attributes.img_class : ''">
                                                        <input type="hidden"
                                                            :name="dataMainFieldName + '[' + blockIndex + '][' + field.name + '][' + subBlockIndex + '][' + subField.name + '][]'"
                                                            :value="image">
                                                    </div>
                                                </div>
                                            </transition-group>
                                        </draggable>
                                        <input type="file" class="d-none" @change="uploadImage($event, block, subField, subBlock)"
                                            :ref="'input_file_' + blockIndex + '_' + subBlockValuesIndex + '_' + subFieldIndex"
                                            :multiple="subField.attributes && subField.validation.max && subField.validation.max == 1 ? false : true">
                                        <div class="btn btn-secondary btn-sm mb-2"
                                            @click="openFileInput('input_file_' + blockIndex + '_' + subBlockValuesIndex + '_' + subFieldIndex)">
                                            <i class="la la-image"></i> Upload images
                                        </div>
                                    </div>
                                    <!-- ERROR -->
                                    <div v-if="errors.length">
                                        <div v-for="error in errors"
                                            v-if="error.blockIndex === blockIndex && error.subBlockIndex === subBlockIndex && error.fieldName === subField.name"
                                            class="text-danger">{{ error.message }}</div>
                                    </div>
                                    <!-- HINT -->
                                    <div v-if="subField.hint"><small class="text-muted" v-html="subField.hint"></small></div>
                                    <!-- VALIDATION HINT -->
                                    <small v-if="subField.validation && (subField.validation.max || subField.validation.min)"
                                        class="text-muted">
                                        <div
                                            v-if="subField.type === 'images' && subField.attributes && subField.attributes.width && subField.attributes.height">
                                            Recommended size: {{ subField.attributes.width }}x{{ subField.attributes.height }}px
                                        </div>
                                        <div v-if="subField.validation.max">Max: {{ subField.validation.max }}</div>
                                        <div v-if="subField.validation.min">Min: {{ subField.validation.min }}</div>
                                    </small>
                                </div>
                            </div>
                            <div class="text-center mt-3">
                                <div @click="addSubBlock(field)"
                                    class="btn btn-secondary btn-sm">
                                    <i class="las la-plus"></i> Add new item
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div @click="addBlock(null)" class="border border-dashed text-center cursor-pointer p-2">
            <i class="las la-plus-square la-lg text-muted"></i>
        </div>
        <div id="block-selection-modal" class="modal fade" role="dialog" aria-hidden="true" tabblockIndex="-1">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add a new block</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div v-for="pageBlock in pageBlocks" class="col-md-4 mb-md-3 cursor-pointer" :key="pageBlock.type"
                                @click="pushNewBlock(pageBlock)">
                                <img :src="pageBlock.template" :alt="pageBlock.title" class="img-fluid border mb-2">
                                <div class="text-center">{{ pageBlock.title }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import { VueEditor, Quill } from "vue2-editor";
export default {
    components: {
        draggable,
    },
    props: ['dataMainFieldName', 'dataBlockValues'],
    data() {
        return {
            blocks: [],
            pageBlocks: window.pageBlocks,
            blockIndex: 0,
            errors: [],
        }
    },
    mounted() {
        // listen to form submit event and block it
        document.querySelectorAll('form .dropdown-item, form button[type="submit"]').forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault()
                e.stopPropagation()

                var saveActions = document.getElementById('saveActions'),
                    crudForm = saveActions.closest('form');

                // saveActions.find('.dropdown-menu').removeClass('show');
                document.querySelector('#saveActions .dropdown-menu').classList.remove('show');

                this.validateFields()

                if (this.errors.length) {
                    return false
                } else {
                    // if target has class dropdown-item then continue to script else submit the form
                    if (e.target.classList.contains('dropdown-item')) {
                        var saveActionField = document.querySelector('[name="save_action"]');

                        var saveAction = e.target.getAttribute('data-value');
                        saveActionField.value = saveAction;
                        crudForm.submit();
                    } else {
                        crudForm.submit();
                    }
                }
            })
        })
        // dataBlockValues is formatted like this
        // [0 => {
        //     "name": "title_subtitle_text"
        //     "title": "hgvjnh"
        // }]
        // extract the values from the dataBlockValues and assign them to the blocks
        if (this.dataBlockValues) {
            let blocks = []
            JSON.parse(this.dataBlockValues).forEach(block => {
                // find the block from the pageBlocks
                let pageBlock = this.pageBlocks.find(pageBlock => pageBlock.name === block.name)
                if (pageBlock) {
                    let newBlock = {
                        name: block.name,
                        title: pageBlock.title,
                        template: pageBlock.template,
                        fields: pageBlock.fields.map(field => {
                            return {
                                name: field.name,
                                label: field.label,
                                class: field.class,
                                type: field.type,
                                hint: field.hint,
                                attributes: field.attributes,
                                validation: field.validation,
                                value: block[field.name] ? block[field.name] : null,
                                fields: field.fields ? field.fields : [],
                            }
                        }),
                    }
                    blocks.push(newBlock)
                }
            })
            this.blocks = blocks
        }
    },
    methods: {
        pushNewBlock(block) {
            let blockClone = JSON.parse(JSON.stringify(block))
            if (this.blocks && this.blocks.length) {
                let valuesToKeep = this.blocks.slice(0, this.blockIndex)
                valuesToKeep.push(blockClone)
                this.blocks = valuesToKeep.concat(this.blocks.slice(this.blockIndex))
            } else {
                this.blocks = [blockClone]
            }
            $('#block-selection-modal').modal('hide')
        },
        addBlock(blockIndex = null) {
            if (this.blocks) {
                this.blockIndex = blockIndex !== null ? blockIndex : this.blocks.length
            } else {
                this.blockIndex = 0
            }
            $('#block-selection-modal').appendTo("body").modal('show')
        },
        addSubBlock(field) {
            field.value.push(field.fields.reduce((acc, field) => {
                acc[field.name] = null
                return acc
            }, {}))
        },
        validateFields() {
            this.errors = []
            this.blocks.forEach((block, blockIndex) => {
                block.fields.forEach(field => {
                    if (field.type != 'repeatable') {
                        if (field.validation) {
                            if (field.validation.required && (!field.value || !field.value.length)) {
                                this.errors.push({
                                    blockIndex: blockIndex,
                                    fieldName: field.name,
                                    message: "This field is required"
                                })
                            } else if (field.validation.min && field.value.length < field.validation.min) {
                                this.errors.push({
                                    blockIndex: blockIndex,
                                    fieldName: field.name,
                                    message: "Min " + field.validation.min + (field.type === 'images' ? ' images' : ' characters')
                                })
                            } else if (field.validation.max && field.value.length > field.validation.max) {
                                this.errors.push({
                                    blockIndex: blockIndex,
                                    fieldName: field.name,
                                    message: "Max " + field.validation.max + (field.type === 'images' ? ' images' : ' characters')
                                })
                            }
                        }
                    }
                    else {
                        field.fields.forEach((subField, subFieldIndex) => {
                            field.value.forEach((subBlock, subBlockIndex) => {
                                if (subField.validation) {
                                    if (subField.validation.required && (!subBlock[subField.name] || !subBlock[subField.name].length)) {
                                        this.errors.push({
                                            blockIndex: blockIndex,
                                            subBlockIndex: subBlockIndex,
                                            fieldName: subField.name,
                                            message: "This field is required"
                                        })
                                    } else if (subField.validation.min && subBlock[subField.name].length < subField.validation.min) {
                                        this.errors.push({
                                            blockIndex: blockIndex,
                                            subBlockIndex: subBlockIndex,
                                            fieldName: subField.name,
                                            message: "Min " + subField.validation.min + (subField.type === 'images' ? ' images' : ' characters')
                                        })
                                    } else if (subField.validation.max && subBlock[subField.name].length > subField.validation.max) {
                                        this.errors.push({
                                            blockIndex: blockIndex,
                                            subBlockIndex: subBlockIndex,
                                            fieldName: subField.name,
                                            message: "Max " + subField.validation.max + (subField.type === 'images' ? ' images' : ' characters')
                                        })
                                    }
                                }
                            })
                        })
                    }
                })
            })
            if (this.errors.length) {
                this.displayAlert("error", "Form validation error")
                return false
            }
            return true
        },
        openFileInput(ref) {
            this.$refs[ref][0].click()
        },
        deleteImage(field, image) {
            field.value = field.value.filter(item => item !== image)
        },
        uploadImage(e, block, field, subBlock = null) {
            var files = e.target.files
            if (!files.length) return;
            if (files.length + (field.value ? field.value.length : 0) > field.validation.max) {
                this.displayAlert("error", "Max images allowed: " + field.validation.max);
                return;
            }

            this.displayAlert("info", "Uploading file...");

            var formData = new FormData();
            for (var i = 0; i < files.length; i++) {
                let file = files[i];
                formData.append("images[" + i + "]", file);
            }
            if (field.value) {
                formData.append("saved_images", JSON.stringify(field.value));
            }

            formData.append("path", field.attributes && field.attributes.path ? field.attributes.path : 'images/uploads');
            formData.append("width", field.attributes && field.attributes.width ? field.attributes.width : 300);
            formData.append("height", field.attributes && field.attributes.height ? field.attributes.height : 300);
            formData.append("max_images", field.validation.max ? field.validation.max : null);

            axios
                .post("/admin/ajax/images/upload", formData)
                .catch((error) => {
                    this.displayAlert(
                        "error",
                        "Upload failed"
                    );
                })
                .then((response) => {
                    if (response.data.success) {
                        // this.displayAlert("success", "New images added!");
                        if (subBlock) {
                            subBlock[field.name] = response.data.images;
                        } else {
                            field.value = response.data.images;
                        }
                    } else if (!response.data.success) {
                        this.displayAlert("error", response.data.msg);
                    }
                    // reset all file inputs
                    e.target.value = null;
                });
        },
    }
}
</script>
